import { GoogleFontProperties } from 'common/utils/fontsUtils'
import { PageEntityInterface } from '../types/base-entity-interface'
import {
  GlobalFontProperties,
  GoogleFontsGenerator,
} from './google-fonts-generator'
import { isDuplicatedGoogleFont } from './is-duplicated-google-font'

export class WebsiteGoogleFontsGenerator extends GoogleFontsGenerator {
  public generateFonts(
    entities: PageEntityInterface[],
    globalFontProperties: GlobalFontProperties,
    websiteStylesTypography: GoogleFontProperties[],
  ) {
    const entitiesFontCss = super.generate(entities, globalFontProperties)

    const websiteStylesFontProperties: GoogleFontProperties[] = []
    websiteStylesTypography.forEach(fv => {
      if (
        this.isGoogleFontVariant(fv) &&
        !isDuplicatedGoogleFont(fv, websiteStylesFontProperties)
      ) {
        websiteStylesFontProperties.push(fv)
      }
    })
    const websiteStylesFontCss = this.getFontFace(websiteStylesFontProperties)

    return `${entitiesFontCss}\n${websiteStylesFontCss}`
  }
}
